import { ROUTER_URL } from "../../../../constants/routerUrl";

const StaffCommunication = () => {
  return (
    <>
      <section id="content">
        <header>
          <h1>Staff Portal</h1>
          <div className="right-wrap">
            <div className="search">
              <input type="text" placeholder="Search" />
              <button style={{ top: 0, right: 0, height: "44px;" }}>
                <img src="/assets/images/icon/ai.svg" alt="" />
              </button>
            </div>
            <ul className="btn-notify">
              <li className="email">
                <a href={ROUTER_URL.STAFF_SENDTOMAIL} title="Send Email">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
                      stroke="#50306D"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                      stroke="#50306D"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </li>
              <li className="safety" title="Safety Alert">
                <a href="javascript:void(0)">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.0206 2.91003C8.71058 2.91003 6.02058 5.60003 6.02058 8.91003V11.8C6.02058 12.41 5.76058 13.34 5.45058 13.86L4.30058 15.77C3.59058 16.95 4.08058 18.26 5.38058 18.7C9.69058 20.14 14.3406 20.14 18.6506 18.7C19.8606 18.3 20.3906 16.87 19.7306 15.77L18.5806 13.86C18.2806 13.34 18.0206 12.41 18.0206 11.8V8.91003C18.0206 5.61003 15.3206 2.91003 12.0206 2.91003Z"
                      stroke="#BF5832"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                    />
                    <path
                      d="M13.8699 3.2C13.5599 3.11 13.2399 3.04 12.9099 3C11.9499 2.88 11.0299 2.95 10.1699 3.2C10.4599 2.46 11.1799 1.94 12.0199 1.94C12.8599 1.94 13.5799 2.46 13.8699 3.2Z"
                      stroke="#BF5832"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.0195 19.06C15.0195 20.71 13.6695 22.06 12.0195 22.06C11.1995 22.06 10.4395 21.72 9.89953 21.18C9.35953 20.64 9.01953 19.88 9.01953 19.06"
                      stroke="#BF5832"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                    />
                  </svg>
                  <span className="notification-count">6</span>
                </a>
                <div className="header-notify">
                  <div className="card-wrap">
                    <h2 className="mb-3">Campus Safety Alerts</h2>
                    <ul className="transactions-wrap m-0">
                      <li>
                        <div className="img img-orange">
                          <img src="/assets/images/icon/warning.svg" alt="" />
                        </div>
                        <div className="w-100">
                          <div className="d-flex align-items-center justify-content-between mb-1">
                            <h6 className="m-0">New Storm Alert</h6>
                            <p className="date">1:40 PM</p>
                          </div>
                          <p className="h-40">
                            Vestibulum mattis enim in mi aliquam, at facilisis
                            nibh laoreet. In hac habitasse plat enim in mi
                            aliquam.
                          </p>
                        </div>
                      </li>

                      <li>
                        <div className="img img-orange">
                          <img src="/assets/images/icon/warning.svg" alt="" />
                        </div>
                        <div className="w-100">
                          <div className="d-flex align-items-center justify-content-between mb-1">
                            <h6 className="m-0">
                              Evacuation Plan on New Building
                            </h6>
                            <p className="date">12:15 PM</p>
                          </div>
                          <p className="h-40">
                            Vestibulum mattis enim in mi aliquam, at facilisis
                            nibh laoreet. In hac habitasse plat enim in mi
                            aliquam.
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="img img-orange">
                          <img src="/assets/images/icon/warning.svg" alt="" />
                        </div>
                        <div className="w-100">
                          <div className="d-flex align-items-center justify-content-between mb-1">
                            <h6 className="m-0">
                              Mockup Drill on next Tuesday
                            </h6>
                            <p className="date">06:00 AM</p>
                          </div>
                          <p className="h-40">
                            Vestibulum mattis enim in mi aliquam, at facilisis
                            nibh laoreet. In hac habitasse plat enim in mi
                            aliquam.
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="btn-flex w-100">
                          <button
                            className="btn btn-primary w-100"
                            data-bs-toggle="modal"
                            data-bs-target="#contactteam"
                          >
                            Contact Team
                          </button>
                          <button className="btn btn-secondary w-100">
                            View More
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li className="message">
                <a href={ROUTER_URL.STAFF_NOTIFICATIONS} title="Notification">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 2H8C4 2 2 4 2 8V21C2 21.55 2.45 22 3 22H16C20 22 22 20 22 16V8C22 4 20 2 16 2Z"
                      stroke="#2A5A5F"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 9.5H17"
                      stroke="#2A5A5F"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7 14.5H14"
                      stroke="#2A5A5F"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span className="notification-count">2</span>
                </a>
              </li>
              <li className="notification">
                <a href={ROUTER_URL.STAFF_COMMUNICATION} title="Communication">
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.818 15.752C19.818 16.0799 19.7452 16.4169 19.5903 16.7448C19.4355 17.0727 19.2351 17.3824 18.9709 17.6739C18.5246 18.1658 18.0327 18.521 17.4771 18.7487C16.9306 18.9765 16.3385 19.0949 15.7009 19.0949C14.7718 19.0949 13.779 18.8763 12.7314 18.4299C11.6839 17.9836 10.6364 17.3824 9.59805 16.6264C8.55055 15.8613 7.5577 15.0142 6.6104 14.076C5.6722 13.1287 4.82509 12.1358 4.06906 11.0974C3.32215 10.059 2.72098 9.02063 2.28376 7.99135C1.84654 6.95295 1.62793 5.9601 1.62793 5.0128C1.62793 4.3934 1.73723 3.80134 1.95584 3.25482C2.17445 2.69918 2.52058 2.1891 3.00335 1.73366C3.5863 1.15981 4.22391 0.877441 4.89796 0.877441C5.153 0.877441 5.40805 0.932094 5.63576 1.0414C5.87259 1.1507 6.08209 1.31466 6.24605 1.55149L8.35927 4.53004C8.52323 4.75775 8.64164 4.96725 8.72362 5.16764C8.80559 5.35893 8.85114 5.55021 8.85114 5.72328C8.85114 5.94189 8.78738 6.16049 8.65986 6.36999C8.54144 6.57949 8.36838 6.7981 8.14977 7.01671L7.45751 7.7363C7.35731 7.8365 7.31177 7.95491 7.31177 8.10065C7.31177 8.17352 7.32088 8.23728 7.33909 8.31015C7.36642 8.38302 7.39374 8.43767 7.41196 8.49232C7.57592 8.79291 7.85829 9.18459 8.25907 9.65824C8.66896 10.1319 9.10618 10.6147 9.57983 11.0974C10.0717 11.5802 10.5454 12.0265 11.0281 12.4364C11.5018 12.8372 11.8934 13.1104 12.2031 13.2744C12.2487 13.2926 12.3033 13.3199 12.3671 13.3473C12.44 13.3746 12.5128 13.3837 12.5948 13.3837C12.7497 13.3837 12.8681 13.3291 12.9683 13.2289L13.6605 12.5457C13.8883 12.318 14.1069 12.1449 14.3164 12.0356C14.5259 11.9081 14.7354 11.8443 14.9631 11.8443C15.1361 11.8443 15.3183 11.8808 15.5187 11.9627C15.7191 12.0447 15.9286 12.1631 16.1563 12.318L19.1713 14.4585C19.4081 14.6225 19.5721 14.8138 19.6723 15.0415C19.7634 15.2692 19.818 15.4969 19.818 15.752Z"
                      stroke="#70367C"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M16.6568 7.25348C16.6568 6.70696 16.2287 5.86895 15.5911 5.1858C15.0081 4.5573 14.2339 4.06543 13.4688 4.06543"
                      stroke="#70367C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.8448 7.25354C19.8448 3.72847 16.9938 0.877441 13.4688 0.877441"
                      stroke="#70367C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </li>
              <li className="profile profile-drop">
                <a href="javascript:void(0)" title="Signout" id="quicklinks">
                  <img src="/assets/images/profile07.jpg" alt="" />
                </a>
                <div id="quicklinkwrap">
                  <a href="">
                    Staff <img src="/assets/images/checked.png" alt="" />
                  </a>
                  <a href="faculty_dashboard.html">
                    Faculty{" "}
                    <img src="/assets/images/icon/arrow-right.svg" alt="" />
                  </a>

                  <a href="index.html">
                    <img
                      src="/assets/images/logout.png"
                      alt=""
                      className="img-logout"
                    />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </header>
        <div className="card-wrap h-auto">
          <div className="title">
            <h2>Staff Directory</h2>
            <div className="form-group deprtdrop">
              <select name="" id="">
                <option value="">Select Department</option>
                <option value="">Departement 1 </option>
                <option value="">Departement 2</option>
                <option value="">Departement 3</option>
                <option value="">Departement 4</option>
                <option value="">Departement 5</option>
              </select>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mb-3">
              <div className="row">
                <div className="col-grid-5 col-lg-3">
                  <div className="card-connect">
                    <div className="img">
                      <img src="/assets/images/profile02.jpg" alt="" />
                    </div>
                    <div className="desc">
                      <h2>Devon Karl</h2>
                      <h6 className="mb-2">Associate professor</h6>
                      <a href="mailto:devonlane@outlook.com">
                        devonlane@outlook.com
                      </a>{" "}
                      <br />
                      <a href="mailto:+44987654321">(+44) 987 654 3287</a>
                    </div>
                    <div className="btns">
                      <a
                        href="staff-teams.html"
                        target="_blank"
                        className="con-chat"
                        title="Chat"
                      >
                        <img src="/assets/images/icon/chat.svg" alt="" />
                      </a>
                      <a
                        href="javascript:void(0)"
                        className="con-email"
                        data-bs-toggle="modal"
                        data-bs-target="#composewrap"
                        title="Send Email"
                      >
                        <img src="/assets/images/icon/emails.svg" alt="" />
                      </a>
                      <a
                        href="staff-teams.html"
                        className="con-call disabled"
                        target="_blank"
                        title="Call"
                      >
                        <img src="/assets/images/icon/phone.svg" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-grid-5 col-lg-3">
                  <div className="card-connect">
                    <div className="img">
                      <img src="/assets/images/profile07.jpg" alt="" />
                    </div>
                    <div className="desc">
                      <h2>Devon Lane</h2>
                      <h6 className="mb-2">Associate professor</h6>
                      <a href="mailto:devonlane@outlook.com">
                        devonlane@outlook.com
                      </a>{" "}
                      <br />
                      <a href="mailto:+44987654321">(+44) 987 654 3287</a>
                    </div>
                    <div className="btns">
                      <a
                        href="staff-teams.html"
                        target="_blank"
                        className="con-chat"
                        title="Chat"
                      >
                        <img src="/assets/images/icon/chat.svg" alt="" />
                      </a>
                      <a
                        href="javascript:void(0)"
                        className="con-email"
                        data-bs-toggle="modal"
                        data-bs-target="#composewrap"
                        title="Send Email"
                      >
                        <img src="/assets/images/icon/emails.svg" alt="" />
                      </a>
                      <a
                        href="staff-teams.html"
                        className="con-call disabled"
                        target="_blank"
                        title="Call"
                      >
                        <img src="/assets/images/icon/phone.svg" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-grid-5 col-lg-3">
                  <div className="card-connect">
                    <div className="img">
                      <img src="/assets/images/profile08.jpg" alt="" />
                    </div>
                    <div className="desc">
                      <h2>Devon Lane</h2>
                      <h6 className="mb-2">Associate professor</h6>
                      <a href="mailto:devonlane@outlook.com">
                        devonlane@outlook.com
                      </a>{" "}
                      <br />
                      <a href="mailto:+44987654321">(+44) 987 654 3287</a>
                    </div>
                    <div className="btns">
                      <a
                        href="staff-teams.html"
                        target="_blank"
                        className="con-chat"
                        title="Chat"
                      >
                        <img src="/assets/images/icon/chat.svg" alt="" />
                      </a>
                      <a
                        href="javascript:void(0)"
                        className="con-email"
                        data-bs-toggle="modal"
                        data-bs-target="#composewrap"
                        title="Send Email"
                      >
                        <img src="/assets/images/icon/emails.svg" alt="" />
                      </a>
                      <a
                        href="staff-teams.html"
                        className="con-call disabled"
                        target="_blank"
                        title="Call"
                      >
                        <img src="/assets/images/icon/phone.svg" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-grid-5 col-lg-3">
                  <div className="card-connect">
                    <div className="img">
                      <img src="/assets/images/profile04.jpg" alt="" />
                    </div>
                    <div className="desc">
                      <h2>Devon Lane</h2>
                      <h6 className="mb-2">Associate professor</h6>
                      <a href="mailto:devonlane@outlook.com">
                        devonlane@outlook.com
                      </a>{" "}
                      <br />
                      <a href="mailto:+44987654321">(+44) 987 654 3287</a>
                    </div>
                    <div className="btns">
                      <a
                        href="staff-teams.html"
                        target="_blank"
                        className="con-chat"
                        title="Chat"
                      >
                        <img src="/assets/images/icon/chat.svg" alt="" />
                      </a>
                      <a
                        href="javascript:void(0)"
                        className="con-email"
                        data-bs-toggle="modal"
                        data-bs-target="#composewrap"
                        title="Send Email"
                      >
                        <img src="/assets/images/icon/emails.svg" alt="" />
                      </a>
                      <a
                        href="staff-teams.html"
                        className="con-call disabled"
                        target="_blank"
                        title="Call"
                      >
                        <img src="/assets/images/icon/phone.svg" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-grid-5 col-lg-3">
                  <div className="card-connect">
                    <div className="img">
                      <img src="/assets/images/profile05.jpg" alt="" />
                    </div>
                    <div className="desc">
                      <h2>Devon Lane</h2>
                      <h6 className="mb-2">Associate professor</h6>
                      <a href="mailto:devonlane@outlook.com">
                        devonlane@outlook.com
                      </a>{" "}
                      <br />
                      <a href="mailto:+44987654321">(+44) 987 654 3287</a>
                    </div>
                    <div className="btns">
                      <a
                        href="staff-teams.html"
                        target="_blank"
                        className="con-chat"
                        title="Chat"
                      >
                        <img src="/assets/images/icon/chat.svg" alt="" />
                      </a>
                      <a
                        href="javascript:void(0)"
                        className="con-email"
                        data-bs-toggle="modal"
                        data-bs-target="#composewrap"
                        title="Send Email"
                      >
                        <img src="/assets/images/icon/emails.svg" alt="" />
                      </a>
                      <a
                        href="staff-teams.html"
                        className="con-call disabled"
                        target="_blank"
                        title="Call"
                      >
                        <img src="/assets/images/icon/phone.svg" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-grid-5 col-lg-3">
                  <div className="card-connect">
                    <div className="img">
                      <img src="/assets/images/profile06.jpg" alt="" />
                    </div>
                    <div className="desc">
                      <h2>Devon Lane</h2>
                      <h6 className="mb-2">Associate professor</h6>
                      <a href="mailto:devonlane@outlook.com">
                        devonlane@outlook.com
                      </a>{" "}
                      <br />
                      <a href="mailto:+44987654321">(+44) 987 654 3287</a>
                    </div>
                    <div className="btns">
                      <a
                        href="staff-teams.html"
                        target="_blank"
                        className="con-chat"
                        title="Chat"
                      >
                        <img src="/assets/images/icon/chat.svg" alt="" />
                      </a>
                      <a
                        href="javascript:void(0)"
                        className="con-email"
                        data-bs-toggle="modal"
                        data-bs-target="#composewrap"
                        title="Send Email"
                      >
                        <img src="/assets/images/icon/emails.svg" alt="" />
                      </a>
                      <a
                        href="staff-teams.html"
                        className="con-call disabled"
                        target="_blank"
                        title="Call"
                      >
                        <img src="/assets/images/icon/phone.svg" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        className="modal fade"
        id="composewrap"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="composewrapLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <h2>Compose</h2>
              <p>
                Summarize your query briefly and send it to the chosen
                recipient. You can expect a reply within 24 hours.
              </p>

              <div className="emailform mt-3">
                <div className="label-to">
                  <label htmlFor="">From</label>
                  <div className="stude-details">
                    <div className="img">
                      <img src="/assets/images/profile06.jpg" alt="" />
                    </div>
                    <div className="desc">
                      <h6>William Sonoma</h6>
                      <p>
                        Departement of Science | <span>Imperial College</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="label-to">
                  <label htmlFor="">To</label>
                  <div className="stude-details">
                    <div className="img">
                      <img src="/assets/images/profile02.jpg" alt="" />
                    </div>
                    <div className="desc">
                      <h6>Devon Karl</h6>
                      <p>
                        Departement of Science | <span>Imperial College</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="formgroup">
                  <label htmlFor="">Subject</label>
                  <input type="text" />
                </div>
                <div className="formgroup">
                  <label htmlFor="">Message</label>
                  <textarea name="" id=""></textarea>
                </div>
              </div>
            </div>
            <div className="modal-footer mb-4">
              <button type="button" className="btn btn-primary">
                Send
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaffCommunication;
